import { CompetitionsMenuSchema } from '@/views/sports/components/CompetitionsMenu/styles/CompetitionsMenu.styles';

export const competitionsMenuStyles: CompetitionsMenuSchema = {
  accordion: {
    color: 'white',
    minW: '190px',
    mr: '3',
    height: 'fit-content',
    py: '3px',
    px: '1px',
    bgGradient:
      'linear(to-b, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.05))',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
    border: '1px solid rgba(255, 255, 255, 0.16)',
    borderRadius: 'md',
    overflow: 'hidden',
    backgroundPosition: '-370px 0px',
    bgSize: '364px',
    bgBlendMode: 'overlay',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    mb: '1px',
    mx: '0.5',
    _first: {
      borderTopRadius: 'md',
    },
    _last: {
      mb: '0',
      borderBottomRadius: 'md',
    },
    pos: 'relative',
    _notFirst: {
      borderTopColor: 'rgba(0, 0, 0, 0.25)',
      borderTopStyle: 'dotted',
      borderTopWidth: '1px',
    },
    _before: {
      mx: '1',
      border: 'inherit',
      borderColor: 'rgba(255, 255, 255, 0.1)',
      content: '""',
      h: '1px',
      left: '0',
      pos: 'absolute',
      right: '0',
      top: '0',
    },
  },
  accordionButton: {
    pl: '3',
    pr: '2',
  },
  accordionHeadingText: {
    flex: '1',
    textAlign: 'left',
    fontWeight: 'bold',
    textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    color: 'white',
    fontFamily: 'accent',
    letterSpacing: '1px',
    fontSize: 'sm',
  },
  accordionIcon: {
    color: 'white',
  },
  accordionPanel: {
    p: '0',
    fontSize: 'xs',
  },
};
